import { apiClient } from './apiClient';

export type Contact = {
  id: string;
  companyId: string;
  companyName: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phone?: string | null;
  jobTitle?: string | null;
  isPrimary: boolean;
  isActive: boolean;
  communicationRoleIds: string[];
  createdAtUtc: string;
  updatedAtUtc: string;
};

export type ContactListResult = {
  items: Contact[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export type ContactUpsertPayload = {
  companyId: string;
  firstName: string;
  lastName?: string;
  email: string;
  phone?: string;
  jobTitle?: string;
  isPrimary?: boolean;
  isActive?: boolean;
  communicationRoleIds?: string[];
};

export async function listContacts(
  params: {
    companyId?: string;
    activeOnly?: boolean;
    search?: string;
    page?: number;
    pageSize?: number;
  } = {},
): Promise<ContactListResult> {
  const response = await apiClient.get<ContactListResult>('/v1/core/contacts', { params });
  return response.data;
}

export async function createContact(payload: ContactUpsertPayload): Promise<Contact> {
  const response = await apiClient.post<Contact>('/v1/core/contacts', payload);
  return response.data;
}

export async function updateContact(id: string, payload: ContactUpsertPayload): Promise<Contact> {
  const response = await apiClient.put<Contact>(`/v1/core/contacts/${id}`, payload);
  return response.data;
}

export async function deleteContact(id: string): Promise<void> {
  await apiClient.delete(`/v1/core/contacts/${id}`);
}
